import $ from 'jquery';

import cookieConsent from 'cookieconsent';
import cookieConsentCss from 'cookieconsent/build/cookieconsent.min.css';

import 'simplebar';
import 'simplebar/dist/simplebar.css';

import navigationToggle from './navigationToggle';
import mainNavigation from './mainNavigation';
import bodyScrollClass from './bodyScrollClass';
import projectSlider from './projectSlider';
import carousel from './carousel';
import intro from './intro';
import projectText from './projectText';

window.$ = $;

document.addEventListener('DOMContentLoaded', event => {
  navigationToggle();
  mainNavigation();
  bodyScrollClass();
  intro();
  projectText();
  projectSlider();
  carousel();

  console.log('development: neuedaten.de')
});
